<template>
  <el-container>
    <div class="container">
      <div class="box">
        <el-table
            :data="tableData.filter(searchFilter)"
            style="width: 100%; margin-top: 10px"
            :default-sort="{prop: 'id', order: 'descending'}"
            @cell-mouse-enter="handleCellEnter"
            @cell-mouse-leave="handleCellLeave"
            @cell-click="handleCellClick"
        >
          <el-table-column
              prop="id"
              label="id"
              sortable
              width="60">
          </el-table-column>
          <el-table-column
              prop="game"
              label="游戏"
              sortable
              :filters="[{ text: '无畏契约', value: 1 }, { text: 'CS2', value: 2 }]"
              :filter-method="filterGame"
              width="100">
            <template slot-scope="scope">
              <el-tag
                  type=primary
                  disable-transitions>{{ scope.row.game === 1 ? '无畏契约' : 'CS2' }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column
              prop="map_name"
              label="地图"
              sortable
              width="100"
          >
          </el-table-column>
          <el-table-column
              prop="blog_id"
              label="文章id"
              sortable
              width="120">
            <template slot-scope="scope">
              <a :href="'/discuss/'+scope.row.blog_id" target="_blank">{{ scope.row.blog_id }}</a>
            </template>
          </el-table-column>
          <el-table-column
              prop="create_time"
              label="创建时间"
              width="200"
              sortable
          >
            <template slot-scope="scope">
              {{ formatISOTime(scope.row.create_time) }}
            </template>
          </el-table-column>
          <el-table-column
              prop="ability"
              label="技能/道具种类"
              width="200"
              :filters="[{ text: '1', value: 1 }, { text: '2', value: 2 },{ text: '3', value: 3 },{ text: '4', value: 4 }]"
              :filter-method="filterAbility"
          >
            <template slot-scope="scope">

              <template v-if="scope.row.game===2">
                {{ scope.row.ability }}
                <template v-if="scope.row.ability===1">
                  <el-tag>
                    烟
                  </el-tag>
                </template>
                <template v-if="scope.row.ability===2">
                  <el-tag>
                    火
                  </el-tag>
                </template>
                <template v-if="scope.row.ability===3">
                  <el-tag>
                    雷
                  </el-tag>
                </template>
                <template v-if="scope.row.ability===4">
                  <el-tag>
                    闪
                  </el-tag>
                </template>
              </template>
              <template v-else>
                {{ scope.row.ability }}
              </template>
            </template>
          </el-table-column>
          <el-table-column
              prop="lineup_title"
              label="lineup标题"
              width="200"
          >
            <template slot-scope="scope">
              <!-- 通过issalSelected显示或隐藏 -->
              <el-input v-if="scope.row.isLineupTitleSelected" v-model="scope.row.lineup_title"
                        @focus="focusEvent(scope.row,scope.$index,scope.column)"
                        @blur="blurEvent(scope.row,scope.$index,scope.column)" v-focus></el-input>
              <p style="min-width: 200px; min-height: 23px" @click="cellClick(scope.row, scope.column)" v-else>
                {{ scope.row.lineup_title }}</p>
            </template>
          </el-table-column>
          <el-table-column
              prop="blog_image_video"
              label="视频/图片"
              :filters="[{ text: '视频+图片', value: 1 }, { text: '视频', value: 2 }, { text: '图片', value: 3 }, { text: '无', value: 0 }]"
              :filter-method="filterBlogImageVideo"
              width="200"
          >
            <template slot-scope="scope">
              <template v-if="scope.row.blog_image_video===1">
                <el-tag type="success" style="margin-right: 10px">
                  视频
                </el-tag>
                <el-tag>
                  图片
                </el-tag>
              </template>
              <template v-else-if="scope.row.blog_image_video===2">
                <el-tag type="success">
                  视频
                </el-tag>
              </template>
              <template v-else-if="scope.row.blog_image_video===3">
                <el-tag>
                  图片
                </el-tag>
              </template>
              <template v-else>

              </template>
            </template>
          </el-table-column>
          <el-table-column
              prop="side"
              label="选边"
              width="300"
              sortable
          >
            <template slot-scope="scope">
              <el-radio-group v-model="scope.row.side" @change="sideChange(scope.row, $event)">
                <el-radio-button :label="0">未分配</el-radio-button>
                <el-radio-button :label="1">进攻</el-radio-button>
                <el-radio-button :label="2">防守</el-radio-button>
              </el-radio-group>
            </template>
          </el-table-column>
          <el-table-column
              prop="start_image"
              label="站位图"
              width="200"
          >
            <template slot-scope="scope">
              <!-- 通过issalSelected显示或隐藏 -->
              <el-input v-if="scope.row.isStartImageSelected" v-model="scope.row.start_image"
                        @focus="focusEvent(scope.row,scope.$index,scope.column)"
                        @blur="blurEvent(scope.row,scope.$index,scope.column)" v-focus></el-input>
              <p style="min-width: 200px; min-height: 23px" @click="cellClick(scope.row, scope.column)" v-else>
                {{ scope.row.start_image }}</p>
            </template>
          </el-table-column>
          <el-table-column
              align="right"
              width="300"
          >
            <template slot="header" slot-scope="scope">
              <el-input
                  :a="scope"
                  v-model="search"
                  size="mini"
                  placeholder="输入关键字搜索"
              />
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>

  </el-container>
</template>

<script>
import axios from 'axios'
import {formatISOTime} from "@/common/comm";

export default {
  name: "Lineup",
  data() {
    return {
      tableData: [],
      search: '',
      formatISOTime,
    }
  },
  mounted() {
    this.getAllLineup()
  },
  directives: {
    focus: {
      inserted: function (el) {
        el.querySelector('input').focus()
      }
    }
  },
  methods: {
    getAllLineup() {
      axios({
        method: 'get',
        url: '/api/blogs/get_all_lineup',
      }).then(r => {
        if (r.data.code === 0) {
          this.tableData = r.data.list
          this.tableData = this.tableData.map((item) => {
            return {
              ...item,
              isStartImageSelected: false,
              isLineupTitleSelected: false,
            }
          })
        } else {
          this.$message.error('加载失败');
        }
      })
    },
    sideChange(row, side) {
      axios({
        method: 'post',
        url: '/api/blogs/edit_lineup_side',
        data: {
          id: row.id,
          side: side
        },
      }).then(r => {
        if (r.data.code === 0) {
          this.$message.success('修改成功');
        } else {
          this.$message.error('修改失败');
        }
      })
    },
    filterGame(value, row) {
      return row.game === value
    },
    filterBlogImageVideo(value, row) {
      return row.blog_image_video === value
    },
    filterAbility(value, row) {
      return row.ability === value
    },
    searchFilter(data) {
      if (data.id.toString().includes(this.search.toString())) {
        return true
      }
      if (data.blog_id.toString().includes(this.search.toString())) {
        return true
      }
      if (data.lineup_title.toString().includes(this.search.toString())) {
        return true
      }
      return false
    },
    //点击输入框聚焦，存储当前值
    focusEvent(row, index, column) {
      if (column.label === "站位图") {
        row.oldStartImage = row.start_image;
      }
      if (column.label === 'lineup标题') {
        row.oldLineupTitle = row.lineup_title
      }
    },
    //输入框失去焦点触发,此处用提示框提示修改
    blurEvent(row, curIndex, column) {
      if (column.label === "站位图") {
        row.isStartImageSelected = !row.isStartImageSelected
        if (row.start_image !== row.oldStartImage) {
          axios({
            method: 'post',
            url: '/api/blogs/edit_lineup_start_image',
            data: {
              id: row.id,
              start_image: row.start_image
            },
          }).then(r => {
            if (r.data.code === 0) {
              this.$message.success('修改成功');
            } else {
              this.$message.error('修改失败');
            }
          })
        }
      }
      if (column.label === "lineup标题") {
        row.isLineupTitleSelected = !row.isLineupTitleSelected
        if (row.lineup_title !== row.oldLineupTitle) {
          axios({
            method: 'post',
            url: '/api/blogs/edit_lineup_title',
            data: {
              id: row.id,
              lineup_title: row.lineup_title
            },
          }).then(r => {
            if (r.data.code === 0) {
              this.$message.success('修改成功');
            } else {
              this.$message.error('修改失败');
            }
          })
        }
      }
    },
    cellClick(row, column) {
      if (column.label === "站位图") {
        row.isStartImageSelected = !row.isStartImageSelected
      }
      if (column.label === 'lineup标题') {
        row.isLineupTitleSelected = !row.isLineupTitleSelected
      }
    }
  }
}
</script>

<style scoped>
.container {
  display: flex;
  justify-content: center; /* 水平居中 */
  height: 100vh; /* 占满整个视口 */
}

.box {
}
</style>